import { render } from "./manageTrainingPlan.vue?vue&type=template&id=6847a4e2&scoped=true"
import script from "./manageTrainingPlan?vue&type=script&lang=js"
export * from "./manageTrainingPlan?vue&type=script&lang=js"

import "./manageTrainingPlan.vue?vue&type=style&index=0&id=6847a4e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6847a4e2"]])

export default __exports__